import Typography from 'components/generics/texts/Typography';
import BlackBankIcon from 'public/assets/icons/black_bank.svg';
import { HTMLAttributes } from 'react';
import Skeleton from 'react-loading-skeleton';
import classes from './index.module.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
  loading: boolean;
  accountDigits?: string;
  bankTitle?: string;
}

const BankStateLeftSection = ({ loading, accountDigits, bankTitle }: Props) => {
  return (
    <div className={classes.container}>
      {!loading ? (
        <>
          <BlackBankIcon className={classes.bankIcon} />
          <div className={classes.bankRowDetails}>
            <div>
              <Typography className={classes.bankName}>{bankTitle}</Typography>
              {accountDigits && (
                <Typography className={classes.bankDigits}>
                  {accountDigits}
                </Typography>
              )}
            </div>
          </div>
        </>
      ) : (
        <Skeleton
          width={200}
          height={25}
        />
      )}
    </div>
  );
};

export default BankStateLeftSection;
